export const ARTICLES_QUERY_KEY = 'articles'
export const ARTICLES_UNREAD_COUNT_QUERY_KEY = 'articles-unread-count'
export const ARTICLE_DETAIL_QUERY_KEY = 'article-detail'
export const ARTICLE_RELATED_QUERY_KEY = 'article-related'
export const ARTICLE_READS_QUERY_KEY = 'article-reads'
export const ARTICLE_CATEGORIES_QUERY_KEY = 'article-categories'
